import { Injectable, inject } from '@angular/core';
import { HttpService, UrlService } from '@boels/helpers';
import { ApiContextService } from '../../services';
import { Observable, filter, switchMap, withLatestFrom } from 'rxjs';
import { Debtor } from '@boels/models';
import { HttpHeaders } from '@angular/common/http';
import { CultureFacade } from '../../cultures/facade/cultures.facade';

@Injectable()
export class UserDataGateway {
  #httpService = inject(HttpService);
  #urlService = inject(UrlService);
  #apiContextService = inject(ApiContextService);
  #cultureFacade = inject(CultureFacade);

  getUserDebtorData(b2cToken: string | undefined): Observable<Debtor> {
    if (!b2cToken)
      throw new Error('No Azure B2C token passed to getUserData in gateway');

    return this.#apiContextService.getContext().pipe(
      filter(([baseSite]) => !!baseSite),
      withLatestFrom(this.#cultureFacade.getActiveLanguage()),
      switchMap(([[baseSite], lang]) => {
        const params = [
          ['details', 'true'],
          ['lang', lang],
        ];
        const url = this.#urlService.combineUri(
          baseSite.uid,
          'users',
          'current',
          'info',
        );
        const httpHeader = new HttpHeaders({
          Authorization: `Bearer ${b2cToken}`,
        });
        return this.#httpService.get<Debtor>(url, params, httpHeader);
      }),
    );
  }
}
